import { ITransactionStatus } from '../../types'
import {TApiEnums} from '../../../services/_common'

export function parseTransactionStatuses(response: TApiEnums): ITransactionStatus[] {
    return response.entities.map((item) => ({
        id: item['@id'],
        text: item.text,
    }))
}